import React, { useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import AuthLayout, { AuthField, EMAIL_RE, EMAIL_ERR, PASS_ERR, validPass } from './AuthLayout';
import { usersApi } from '../api/services';
import { setToken } from '../api/http';
import { setUser } from '../store';

export default function Login() {
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const emailOk = EMAIL_RE.test(email);
    const passOk = validPass(password);

    const submit = async (e) => {
        e.preventDefault();
        if (!emailOk || !passOk) return;
        setLoading(true);
        try {
            const user = await usersApi.authenticate(email, password);
            if (user.emailConfirmed && user.token) {
                setToken(user.token);
                dispatch(setUser({ id: user.id, firstName: user.firstName, lastName: user.lastName, email: user.email }));
                window.dispatchEvent(new Event('tacho-auth'));
                const returnUrl = new URLSearchParams(location.search).get('returnUrl');
                history.replace(returnUrl || '/');
            } else {
                history.push('/verify', { user });
            }
        } catch { /* toast prikazuje interceptor */ }
        setLoading(false);
    };

    return (
        <AuthLayout title="Dobro došli nazad" description="Prijavite se da nastavite rad." links={<><Link to="/password-recovery">Lozinka zaboravljena?</Link><Link to="/register">Registracija</Link></>}>
            <form onSubmit={submit} noValidate>
                <AuthField icon="bi-envelope" error={!emailOk && EMAIL_ERR}>
                    <InputText type="email" autoComplete="username" placeholder="E-mail adresa" value={email} onChange={(e) => setEmail(e.target.value)} autoFocus />
                </AuthField>
                <AuthField icon="bi-lock" error={!passOk && PASS_ERR}>
                    <Password autoComplete="current-password" placeholder="Lozinka" value={password} onChange={(e) => setPassword(e.target.value)} feedback={false}
                        toggleMask maxLength={50}
                        style={{ width: '100%' }} />
                </AuthField>
                <Button type="submit" label="Ulogujte se" loading={loading} disabled={loading || !emailOk || !passOk} />
            </form>
        </AuthLayout>
    );
}
